const photos = [
    {
      src: 'carouselImage/carImg2.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg1.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg4.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg3.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg5.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg9.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg7.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg5.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg8.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg6.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg4.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg2.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg5.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg8.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg6.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg4.jpg',
      width: 'image.width',
    },
    {
      src: 'carouselImage/carImg2.jpg',
      width: 'image.width',
    },
];
export default photos;